import React, {ReactNode, Suspense} from 'react';
import {HashRouter as Router, Route, Routes} from 'react-router-dom';
import RequireAuth from "../guards/RequireAuth";
import AppLayout from '../components/AppLayout';
import ResetPassword from "../components/ResetPassword";
import Login from "../components/Login";
import {ApiServiceProvider} from "../context/ApiServiceContext";

// Lazy-loaded so the admin bundle stays out of the main chunk that every
// (mostly phone) user downloads — only admins ever hit this route.
const AdminRouter = React.lazy(() => import('./AdminRouter'));


const MainRoutes: React.FC = () => {

    return (
        <Routes>

            <Route path="admin/*" element={
                <RequireAuth admin={true} redirectTo="/login">
                    <Suspense fallback={null}>
                        <AdminRouter/>
                    </Suspense>
                </RequireAuth>
            }/>
            <Route path="/*" element={
                <RequireAuth redirectTo="/login">
                    <AppLayout/>
                </RequireAuth>
            }/>
            <Route path="reset-password" Component={ResetPassword}/>
            <Route path="login" Component={Login}/>
        </Routes>
    );
};

export default MainRoutes;